var _path, _path2, _path3, _line, _line2, _path4, _path5, _line3, _line4, _path6, _path7, _path8, _path9, _line5, _line6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomePageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.55 18.9C48.331 18.9 44.1 14.6692 44.1 9.44985C44.1 4.23092 48.331 -6.41204e-07 53.55 -4.13072e-07C58.769 -1.84941e-07 63 4.23092 63 9.44985C63 14.6692 58.769 18.9 53.55 18.9Z",
    fill: "#FFB600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5002 18.4C26.5573 18.4 22.5502 14.393 22.5502 9.44985C22.5502 4.50707 26.5573 0.499999 31.5002 0.5C36.4431 0.5 40.4502 4.50707 40.4502 9.44985C40.4502 14.393 36.4431 18.4 31.5002 18.4Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4504 18.4C4.5075 18.4 0.500392 14.393 0.500393 9.44985C0.500393 4.50707 4.50749 0.499999 9.4504 0.5C14.3933 0.5 18.4004 4.50707 18.4004 9.44985C18.4004 14.393 14.3933 18.4 9.4504 18.4Z",
    stroke: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18.1123,
    y1: 8.94922,
    x2: 22.0498,
    y2: 8.94922,
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 40.1641,
    y1: 8.95312,
    x2: 44.1641,
    y2: 8.95312,
    stroke: "url(#paint0_linear_1_66867)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5002 62.4977C26.5572 62.4977 22.5502 58.4907 22.5502 53.5478C22.5502 48.6048 26.5572 44.5977 31.5002 44.5977C36.4431 44.5977 40.4502 48.6049 40.4502 53.5478C40.4502 58.4907 36.4431 62.4977 31.5002 62.4977Z",
    stroke: "#DDDDDD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.55 62.4977C48.607 62.4977 44.6 58.4907 44.6 53.5478C44.6 48.6048 48.607 44.5977 53.55 44.5977C58.4929 44.5977 62.5 48.6049 62.5 53.5478C62.5 58.4907 58.4929 62.4977 53.55 62.4977Z",
    stroke: "#DDDDDD"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 18.1133,
    y1: 53.0508,
    x2: 22.1133,
    y2: 53.0508,
    stroke: "url(#paint1_linear_1_66867)"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 40.1621,
    y1: 53.0469,
    x2: 44.0996,
    y2: 53.0469,
    stroke: "#DDDDDD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.45038 62.9977C4.23122 62.9977 0.000392273 58.7669 0.000392501 53.5478C0.000392729 48.3287 4.23122 44.0977 9.45038 44.0977C14.6694 44.0977 18.9004 48.3287 18.9004 53.5478C18.9004 58.7669 14.6694 62.9977 9.45038 62.9977Z",
    fill: "#EB8C00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5002 40.4527C26.5572 40.4527 22.5502 36.4458 22.5502 31.5028C22.5502 26.5598 26.5572 22.5527 31.5002 22.5527C36.4432 22.5527 40.4502 26.5598 40.4502 31.5028C40.4502 36.4458 36.4432 40.4527 31.5002 40.4527Z",
    stroke: "#252525"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45039 40.4527C4.5074 40.4527 0.500392 36.4458 0.500393 31.5028C0.500393 26.5598 4.50741 22.5527 9.45039 22.5527C14.3934 22.5527 18.4004 26.5598 18.4004 31.5028C18.4004 36.4458 14.3934 40.4527 9.45039 40.4527Z",
    stroke: "#252525"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.55 40.9527C48.3309 40.9527 44.1 36.7219 44.1 31.5028C44.1 26.2836 48.3309 22.0527 53.55 22.0527C58.7691 22.0527 63 26.2836 63 31.5028C63 36.7219 58.7691 40.9527 53.55 40.9527Z",
    fill: "#DB536A"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 18.1123,
    y1: 31.002,
    x2: 22.0498,
    y2: 31.002,
    stroke: "#252525"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 40.1641,
    y1: 31.0059,
    x2: 44.1641,
    y2: 31.0059,
    stroke: "url(#paint2_linear_1_66867)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_66867",
    x1: 42.1641,
    y1: 9.45313,
    x2: 44.0608,
    y2: 9.5015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_66867",
    x1: 20.1133,
    y1: 53.5508,
    x2: 22.0101,
    y2: 53.5992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_66867",
    x1: 40.5,
    y1: 31.498,
    x2: 44.0608,
    y2: 31.5555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB536A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageIcon);
export default __webpack_public_path__ + "static/media/home-page-icon.aeb74856525ca18d31fba1e1123ce017.svg";
export { ForwardRef as ReactComponent };